import { Component, OnInit } from '@angular/core';

export interface TicketFilterItem{
  id?: number
  typeText: string
  description: string
  icon?: string
}

export interface TicketSearchWithOutFilters{
  buttonActive: boolean,
  activeSearch?: boolean
}

@Component({
    selector: 'app-ticket-filter',
    templateUrl: './ticket-filter.component.html',
    styleUrls: ['./ticket-filter.component.scss'],
    standalone: false
})
export class TicketFilterComponent implements OnInit {

  public filterOne: string = "all"
  public filterTwo: string = "all"
  public filterObserver: string = "all"

  public filterOneItems: TicketFilterItem[] = [
    {id: 1, typeText: "all", description: "Alle Tickets", icon: "fa-user-group"},
    {id: 2, typeText: "my", description: "Meine Tickets", icon: "fa-user"},
  ]

  public filterObserverItems: TicketFilterItem[] = [
    {id: 1, typeText: "all", description: "Alle", icon: "fa-puzzle"},
    {id: 2, typeText: "editor", description: "Bearbeiter", icon: "fa-hammer"},
    {id: 3, typeText: "observer", description: "Beobachter", icon: "fa-eye"}
  ]

  public filterTwoItems: TicketFilterItem[] = [
    {id: 1, typeText: "all", description: "Alle", icon: "fa-puzzle"},
    {id: 2, typeText: "open", description: "Offen", icon: "fa-hammer"},
    {id: 3, typeText: "finish", description: "Fertig", icon: "fa-check"},
    {id: 4, typeText: "wait", description: "Warten", icon: "fa-hand"},
  ]

  public newFilterOneSelected: (data: TicketFilterItem) => void
  public newFilterTwoSelected: (value: TicketFilterItem) => void
  public newFilterObserverSelected: (value: TicketFilterItem) => void

  constructor() { }

  ngOnInit() {

  }

  public select(value: string, filterType: "filterOne" | "filterTwo" | "filterObserver"){
    if(filterType === "filterOne")
      this.newFilterOneSelected(this.filterOneItems.find(item => item.typeText === value))
    else if(filterType === "filterTwo")
      this.newFilterTwoSelected(this.filterTwoItems.find(item => item.typeText === value))
    else if(filterType === "filterObserver")
      this.newFilterObserverSelected(this.filterObserverItems.find(item => item.typeText === value))
  }


}
